<template>
  <a-modal v-model="visible" :title="title" :destroyOnClose="true" :width="450">
    <a-form-model ref="changeTrialPeriodForm" :model="trialPeriodInfo" :rules="rules" layout="vertical">
      <a-row :gutter="8">
        <a-col :span="12">
          <a-form-model-item label="End Date" prop="endDate">
            <DateTimePickr :date="trialPeriodInfo.endDate" @input="onEndDateChange" @onChange="onEndDateChange" minDate="today"></DateTimePickr>
          </a-form-model-item>
        </a-col>
        <a-col :span="6" class="update-trial-col">
          <a-button @click="save" :loading="isSaving" type="primary" ghost size="small" class="mt-4">Update Trial</a-button>
        </a-col>
      </a-row>
    </a-form-model>
    <template #footer>
      <a-button @click="activateSubscription" type="primary" :loading="isSaving">Activate Subscription</a-button>
      <a-button @click="terminateTrial" type="danger" :loading="isSaving">Terminate Trial</a-button>
      <a-button @click="cancel">Cancel</a-button>
    </template>
  </a-modal>
</template>

<script>
import modalMixin from '../Common/Mixins/modalMixin';
import { helper } from '../../Utilities/helper';

export default {
  mixins: [modalMixin],
  props: {
    instance: {
      type: Object,
      default: () => ({}),
    },
    isSaving: Boolean,
  },
  data() {
    return {
      trialPeriodInfo: { endDate: null },
      rules: {
        endDate: [
          { required: true, message: 'Please specify the trial end date', trigger: 'blur' },
          { validator: helper.dateFormatValidator, trigger: 'blur' },
        ],
      },
    };
  },
  watch: {
    instance() {
      this.trialPeriodInfo.endDate = this.instance.trialExpiresOn;
    },
  },
  computed: {
    companySubscriptionId() {
      return this.instance.companySubscription?.id;
    },
  },
  methods: {
    onEndDateChange(newDate) {
      this.trialPeriodInfo.endDate = newDate;
    },
    activateSubscription() {
      const self = this;
      this.$confirm({
        title: 'Activate Subscription',
        content: 'Are you sure you want to activate subscription?',
        okText: 'Activate',
        cancelText: 'Cancel',
        onOk() {
          self.$emit('activateSubscription', self.companySubscriptionId);
        },
        onCancel() {},
      });
    },
    terminateTrial() {
      const self = this;
      this.$confirm({
        title: 'Terminate Trial Period',
        content: 'Are you sure you want to terminate the trial immediately?',
        okText: 'Terminate',
        okType: 'danger',
        cancelText: 'Cancel',
        onOk() {
          self.$emit('terminateTrial', self.companySubscriptionId);
        },
        onCancel() {},
      });
    },
    save() {
      const self = this;
      this.$refs.changeTrialPeriodForm.validate(async (valid) => {
        if (valid) {
          self.$emit('changeTrialPeriodEndDate', self.companySubscriptionId, self.trialPeriodInfo.endDate);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.update-trial-col {
  padding-top: 3px;
}
</style>
